import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'
import { useGroup } from '../lib/GroupContext'
import { track, Events } from '../lib/analytics'
import Logo from '../components/Logo'

export default function CreateGroup() {
  const { user } = useAuth()
  const { refreshGroups } = useGroup()
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  async function handleCreate(e) {
    e.preventDefault()
    if (!name.trim()) return
    setLoading(true)
    setError('')

    try {
      const inviteCode = crypto.randomUUID().split('-')[0].toUpperCase()

      const { data: group, error: gErr } = await supabase
        .from('groups')
        .insert({
          name: name.trim(),
          invite_code: inviteCode,
          host_id: user.id,
        })
        .select()
        .single()

      if (gErr) throw gErr

      // Add creator as host member
      await supabase.from('group_members').insert({
        group_id: group.id,
        user_id: user.id,
        role: 'host',
      })

      // Refresh group list and switch to the new group
      await refreshGroups(group.id)
      track(Events.GroupCreated)
      navigate('/')
    } catch (err) {
      setError(err.message)
      setLoading(false)
    }
  }

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <Logo />
          <p className="text-[var(--fp-text-muted)] text-sm mt-2">Create your movie night group</p>
        </div>

        {error && (
          <div className="bg-red-900/30 border border-red-800 text-red-300 text-sm rounded-lg p-3 mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleCreate} className="flex flex-col gap-3">
          <input
            placeholder='Group name (e.g. "Monday Movie Night")'
            value={name}
            onChange={e => setName(e.target.value)}
            className="fp-input"
            autoFocus
            required
          />
          <button type="submit" className="fp-btn fp-btn-primary" disabled={loading}>
            {loading ? 'Creating...' : 'Create group'}
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="fp-btn fp-btn-secondary"
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  )
}
